import { render } from "./base-checkbox.vue?vue&type=template&id=49366a41&ts=true"
import script from "./base-checkbox.vue?vue&type=script&lang=ts"
export * from "./base-checkbox.vue?vue&type=script&lang=ts"

import "./base-checkbox.vue?vue&type=style&index=0&id=49366a41&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__